// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import RakutenPoints from '../_raw/ui/icon_rakuten_points.svg';
import withIconProps from '../withIconProps';

export default withIconProps(RakutenPoints);
